import { OrganizationType } from "../types/Organization";
export const isCustomer = (organizationType) => {
    return organizationType === OrganizationType.CUSTOMER || organizationType === OrganizationType.CUSTOMER_INTERNAL || organizationType === OrganizationType.DISCONTINUED;
};
